export default "<div id=\"smcx-sdk\"></div>\n"